import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addHttp',
  standalone: false,
})
export class AddHttpPipe implements PipeTransform {
  public transform(value: string): string {
    if (value && !value.toLowerCase().startsWith('http://') && !value.toLowerCase().startsWith('https://')) {
      return 'http://' + value;
    } else {
      return value;
    }
  }
}
